<template>
	<div>
		<o-section>
			<div class="flex fd-c g-xs">
				<o-select
					v-model="setup.email.recipients"
					label="Destinataire(s)"
					multiple
					track-key="id"
					display-key="label"
					:validation="setup.validation.rule('recipients')"
					:options="setup.recipientsOptions"
					:readonly="recipients.length === 1"
					required/>
				<o-toggle
					:model-value="setup.addSelfInBcc"
					label="Je souhaite être en copie cachée"
					@click="setup.toggleSelfInBcc()"/>
				<o-select
					:ref="setup._selectBcc"
					v-model="setup.email.bccRecipients"
					label="Cci"
					multiple
					track-key="id"
					display-key="label"
					searchable
					:custom-fetch="setup.getBccRecipientsAsync.bind(setup)"/>

				<o-alert
					v-if="setup.email.bccRecipients.length"
					color="info">
					En positionnant un utilisateur en copie cachée, il sera en Cci de chacun des mails envoyés aux interlocuteurs contactés
				</o-alert>

				<o-input
					v-model="setup.email.subject"
					label="Sujet"
					:validation="setup.validation.rule('subject')"
					required/>

				<o-editor
					v-if="setup.dataLoaded"
					v-model="setup.email.body"
					:validation="setup.validation.rule('body')"
					required
					:config="{ buttonsHide: ['image'] }"/>
			</div>
		</o-section>

		<o-section align="right">
			<o-button
				color="danger"
				outline
				@click="setup.cancel()">
				Annuler
			</o-button>
			<o-button
				color="info"
				@click="setup.sendAsync()">
				Envoyer
			</o-button>
		</o-section>
	</div>
</template>

<script setup lang="ts">
import ModalEmailSetupService from '@/setup/modal/ModalEmailSetupService';
import { inject } from 'vue';
const _modal = inject<OrionModal>('_modal');
const props = defineProps(ModalEmailSetupService.props);
const setup = new ModalEmailSetupService(props, _modal);
</script>
